import { createSelector } from 'reselect'

export const getAdsReportTypes = createSelector(
  state => state && state.ads && state.ads.detail && Array.isArray(state.ads.detail.reportTypes)
    ? state.ads.detail.reportTypes : [],
  reportTypes => reportTypes
)
